import React, { useState, useMemo } from 'react';
import { GrDeploy } from "react-icons/gr";
import { FaPen, FaTrash } from "react-icons/fa";
import { useTranslation } from 'react-i18next';
import { Edit, Eye, EyeSlash, Forbidden, ToggleOffCircle, ToggleOnCircle, Trash } from 'iconsax-reactjs';

const AdvertisementTable = ({
    groupedAdvertisements,
    isLoading,
    toggleAdvertisementShowing,
    setShowEditModal,
    setShowDeleteModal,
    setShowImagesModal
}) => {
    const { t } = useTranslation();
    const tAdvertisementInfo = t("advertisementFormIfno")

    // Search and filter state
    const [searchText, setSearchText] = useState("");
    const [statusFilter, setStatusFilter] = useState("");

    console.log('groupedAdvertisements: ', groupedAdvertisements);

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        // Pad month and day with leading zeros
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    }

    // Filtering logic
    const filteredGroupedAdvertisements = useMemo(() => {
        const result = {};
        Object.entries(groupedAdvertisements).forEach(([priority, ads]) => {
            let filteredAds = ads;
            // Filter by search text
            if (searchText) {
                const lower = searchText.toLowerCase();
                filteredAds = filteredAds.filter(ad => {
                    const priorityStr = String(ad.priority);
                    const startDateStr = formatDate(ad.startDate);
                    const expireDateStr = formatDate(ad.expireDate);
                    return (
                        (ad.title && ad.title.toLowerCase().includes(lower)) ||
                        (ad.arTitle && ad.arTitle.toLowerCase().includes(lower)) ||
                        (ad.subtitle && ad.subtitle.toLowerCase().includes(lower)) ||
                        (ad.arSubtitle && ad.arSubtitle.toLowerCase().includes(lower)) ||
                        priorityStr.includes(lower) ||
                        startDateStr.includes(lower) ||
                        expireDateStr.includes(lower)
                    );
                });
            }
            // Filter by status
            if (statusFilter === "true") {
                filteredAds = filteredAds.filter(ad => ad.isShown === true);
            } else if (statusFilter === "false") {
                filteredAds = filteredAds.filter(ad => ad.isShown === false);
            }
            if (filteredAds.length > 0) {
                result[priority] = filteredAds;
            }
        });
        return result;
    }, [groupedAdvertisements, searchText, statusFilter]);

    return (
        <div className="flex flex-col shadow-3 p-2 rounded-2xl text-black">
            <div className="flex justify-between">
                <input
                    type="text"
                    placeholder={tAdvertisementInfo.searchTxt}
                    className='p-2 m-2 rounded-lg border'
                    value={searchText}
                    onChange={e => setSearchText(e.target.value)}
                />
                <select
                    className='p-2 m-2 rounded-lg border text-sm'
                    name="status"
                    id="status"
                    value={statusFilter}
                    onChange={e => setStatusFilter(e.target.value)}
                >
                    <option value="">{tAdvertisementInfo.statusTxt}</option>
                    <option value={true}>{tAdvertisementInfo["visiable"]}</option>
                    <option value={false}>{tAdvertisementInfo["hidden"]}</option>
                </select>
            </div>
            <div className="overflow-x-scroll sm:-mx-3 lg:-mx-2">
                <div className="inline-block min-w-full py-2">
                    <div className="overflow-hidden">
                        <table className="min-w-full text-center text-sm font-light">
                            <thead className="bg-neutral-100 rounded-lg font-medium dark:border-neutral-500 dark:text-neutral-800">
                                <tr key={"head-1"}>
                                    <th scope="col" className="whitespace-nowrap  p-4">{tAdvertisementInfo.priority.label.replace("*", "")}</th>
                                    <th scope="col" className="whitespace-nowrap  p-4">{tAdvertisementInfo.title.label.replace("*", "")}</th>
                                    <th scope="col" className="whitespace-nowrap  p-4">{tAdvertisementInfo.arTitle.label.replace("*", "")}</th>
                                    <th scope="col" className="whitespace-nowrap  p-4">{tAdvertisementInfo.subtitle.label.replace("*", "")}</th>
                                    <th scope="col" className="whitespace-nowrap  p-4">{tAdvertisementInfo.arSubtitle.label.replace("*", "")}</th>
                                    <th scope="col" className="whitespace-nowrap  p-4">{tAdvertisementInfo.createDate.label.replace("*", "")}</th>
                                    <th scope="col" className="whitespace-nowrap  p-4">{tAdvertisementInfo.expireDate.label.replace("*", "")}</th>
                                    <th scope="col" className="whitespace-nowrap  p-4">{tAdvertisementInfo.startTime.label.replace("*", "")}</th>
                                    <th scope="col" className="whitespace-nowrap  p-4">{tAdvertisementInfo.endTime.label.replace("*", "")}</th>
                                    <th scope="col" className="whitespace-nowrap  p-4">{tAdvertisementInfo.url.label.replace("*", "")}</th>
                                    <th scope="col" className="whitespace-nowrap  p-4">{tAdvertisementInfo.vendorId.label.replace("*", "")}</th>
                                    <th scope="col" className="whitespace-nowrap  p-4">{tAdvertisementInfo.type}</th>
                                    <th scope="col" className="whitespace-nowrap  p-4">{tAdvertisementInfo.adsImage1.label.replace("*", "")}</th>
                                    <th scope="col" className="whitespace-nowrap  p-4">{tAdvertisementInfo.visibility}</th>
                                    <th scope="col" className="whitespace-nowrap  p-1">{t("action")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(filteredGroupedAdvertisements).map(([priority, ads]) => (
                                    <React.Fragment key={priority}>
                                        <tr className="bg-green-100">
                                            <td colSpan="4" className="py-2 px-4 font-semibold">
                                                {tAdvertisementInfo['adsLabel']}: {priority}
                                            </td>
                                        </tr>
                                        {ads.sort((a, b) => {
                                            if (new Date(a.expireDate) > new Date(b.expireDate)) return -1;
                                            if (new Date(a.expireDate) < new Date(b.expireDate)) return 1;
                                            return 0;
                                        }).map((advertisement) => {
                                            // const isWithinDateRange = (new Date(advertisement.createdDate) <= new Date() && new Date(advertisement.expireDate) >= new Date());
                                            const bgColor = advertisement.activatedNow ? "bg-green-200" : "bg-red-200";
                                            const txtColor = advertisement.activatedNow ? "text-green-600" : "text-red-600";

                                            const finalBgColor = advertisement.activatedNow ? "bg-white" : "bg-red-100";

                                            return (
                                                <tr key={advertisement.advertisementId} className={finalBgColor}>
                                                    <td className="whitespace-nowrap p-4">{advertisement.priority}</td>
                                                    <td className="whitespace-nowrap p-4 font-medium capitalize">{advertisement.title}</td>
                                                    <td className="whitespace-nowrap p-4 font-medium capitalize">{advertisement.arTitle}</td>
                                                    <td className="whitespace-nowrap p-4">{advertisement.subtitle === "" ? "_" : advertisement.subtitle ?? "_"}</td>
                                                    <td className="whitespace-nowrap p-4">{advertisement.arSubtitle === "" ? "_" : advertisement.arSubtitle ?? "_"}</td>
                                                    <td className="whitespace-nowrap p-4">{formatDate(advertisement.startDate)}</td>
                                                    <td className="whitespace-nowrap p-4">{formatDate(advertisement.expireDate)}</td>
                                                    <td className="whitespace-nowrap p-4">{advertisement.startTime}</td>
                                                    <td className="whitespace-nowrap p-4">{advertisement.endTime}</td>
                                                    <td className="whitespace-nowrap p-4">
                                                        {advertisement.url
                                                            ? <a className='bg-gray-200 text-xs' target='_blank' href={advertisement.url} rel="noreferrer">Visit</a>
                                                            : "_"}</td>
                                                    <td className="whitespace-nowrap p-4">{advertisement.vendor?.full_name ?? "_"}</td>
                                                    <td className="whitespace-nowrap p-4">{advertisement.vendor == null ? "External" : "Internal"}</td>
                                                    <td className="whitespace-nowrap p-4">
                                                        <button
                                                            onClick={() => setShowImagesModal({ advertisement: advertisement, status: true })}
                                                            className='bg-gray-200 text-xs'>Show Image</button>
                                                    </td>
                                                    <td className="whitespace-nowrap p-4">
                                                        <span className={`px-1 flex items-center text-xs ${!advertisement.isShown ? "text-red-600" : txtColor}`}>
                                                            {!advertisement.activatedNow ? (
                                                                <><Forbidden
                                                                    variant="Bulk"
                                                                />
                                                                    Expired</>
                                                            ) : advertisement.isShown ?
                                                                (<><Eye
                                                                    variant="Bulk"
                                                                />
                                                                    Visiable</>)
                                                                :
                                                                (<><EyeSlash
                                                                    variant="Bulk"
                                                                />
                                                                    Hidden</>
                                                                )
                                                            }
                                                        </span>
                                                    </td>
                                                    <td className="whitespace-nowrap py-4 w-1/4">
                                                        <div className="w-full flex items-center gap-1 justify-center">
                                                            {/* <button
                                                                onClick={() => isLoading ? null : toggleAdvertisementShowing(advertisement.advertisementId)}
                                                                className={`${advertisement.isShown && "bg-green-200"} mx-1`}>
                                                                <GrDeploy />
                                                            </button> */}

                                                            {
                                                                advertisement.isShown ?
                                                                    <ToggleOnCircle
                                                                        title="Switch visibility by clicking the toggle icon"
                                                                        size={32}
                                                                        variant="Bulk"
                                                                        className='text-green-500 cursor-pointer mx-1 hover:text-gray-400 transition-all duration-200 ease-in'
                                                                        onClick={() => isLoading ? null : toggleAdvertisementShowing(advertisement.advertisementId)}
                                                                    />

                                                                    :
                                                                    <ToggleOffCircle
                                                                        title="Set Visibility by clicking the toggle icon"
                                                                        size={32}
                                                                        variant="Bulk"
                                                                        className='text-gray-400 cursor-pointer mx-1 hover:text-green-400 transition-all duration-200 ease-in'
                                                                        onClick={() => isLoading ? null : toggleAdvertisementShowing(advertisement.advertisementId)}
                                                                    />
                                                            }

                                                            <Edit
                                                                size={26}
                                                                className='text-gray-400 cursor-pointer mx-1 hover:text-primary transition-colors duration-200 ease-in'
                                                                variant="Bulk"
                                                                onClick={() => setShowEditModal({ advertisement: advertisement, status: true })}
                                                            />

                                                            <Trash
                                                                className="text-gray-500 cursor-pointer mx-1 hover:text-red-600 transition-colors duration-200 ease-in"
                                                                variant="Bulk"
                                                                onClick={() => setShowDeleteModal({ advertisementId: advertisement.advertisementId, status: true })}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdvertisementTable;